export const GET_TEAMMEMBER_ABORTED = 'GET_TEAMMEMBER_ABORTED';
export const GET_TEAMMEMBER_REQUESTED = 'GET_TEAMMEMBER_REQUESTED';
export const GET_TEAMMEMBER_COMPLETED = 'GET_TEAMMEMBER_COMPLETED';
export const GET_TEAMMEMBER_FAILED = 'GET_TEAMMEMBER_FAILED';
export const RESET_TEAMMEMBER_REQUESTED = 'RESET_TEAMMEMBER_REQUESTED';
export const RESET_TEAMMEMBER_COMPLETED = 'RESET_TEAMMEMBER_COMPLETED';
